import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux';
import PropTypes from 'prop-types'
import BackgroundImage from '../../components/BackgroundImage'
import { Row, Col } from 'react-flexbox-grid';
import { formValueSelector, Field, reduxForm } from 'redux-form'
import Textfield from '../signup/components/Textfield'
import * as Validate from '../../helpers/validations'
import { geURLParam } from '../../helpers/getURLparams'
import signUpStyles from '../signup/styles/signUp.module.scss'
import Button from '../../components/Button'
import loginStyles from '../login/login.module.scss'
import { forgotPasswordVerifyLink, forgotPasswordChangePassword,clearUserState } from '../../actions/user-actions'

export class ChangePassword extends Component {
    constructor(props) {
        super(props);
    
        this.state = {
            isPasswordVisible: false,
            isPasswordConfirmationVisible: false,
        }
    }

    componentDidMount() {
        this.validateLink()
        this.props.clearState();
    }

    validateLink = () => {
        const data = {
            resetPassLink: geURLParam('token'),
            email: geURLParam('user')
        }
        this.props.forgotPasswordVerifyLink(data)
    }

    componentDidUpdate(prevProps){
        if (this.props.verifySuccess && !prevProps.verifySuccess && (this.props.verifyData.result === false || this.props.verifyData.errorType) ) {
            window.location.href = '/'
        }

        if (this.props.passwordSuccess &&  !prevProps.passwordSuccess && this.props.changePassData.result === true ) {
            window.location.href = '/'
        }
    }

    viewPassword = () => {
        this.setState({
            isPasswordVisible: !this.state.isPasswordVisible
        })
    }

    viewConfirmPassword = () => { 
        this.setState({
        isPasswordConfirmationVisible: !this.state.isPasswordConfirmationVisible
        })
    }

    onSubmit = ( password ) => {
        const data = {
            password: password.password,
            email: geURLParam('user'),
            resetPassLink: geURLParam('token'),
        }
        this.props.forgotPasswordChangePassword(data)
    } 

    render() {
        const { isPasswordVisible, isPasswordConfirmationVisible } = this.state
        const passwordType = isPasswordVisible ? 'text' : 'password';
        const confirmPasswordType = isPasswordConfirmationVisible ? 'text' : 'password';
        const { handleSubmit, pristine, submitting, invalid } = this.props;

        return (
            <BackgroundImage form active={this.props.showLoading}>
                <Row>       
                    <Col xs={12}>        
                        <Row center="xs" className={loginStyles.__form}>
                            <Col xs={10}>
                                <Row center="xs" className={signUpStyles.__wrapper}>
                                    <img src="/images/logo.png" className={signUpStyles.__logo} alt="Liveli Logo"/>
                                    <Col xs={12}>
                                        <span className={signUpStyles.__title}>
                                            Reset Password
                                        </span>
                                    </Col>
                                    <Col xs={12}>
                                        <p>
                                            Enter your new password
                                        </p>
                                    </Col>
                                    <Col xs={10}>
                                        <form onSubmit={handleSubmit(this.onSubmit)}>
                                        <Field
                                            name="password"
                                            props={{
                                                viewPassword: true,
                                                input_type: passwordType,
                                                label: 'New Password',
                                                viewPassword_press: this.viewPassword,
                                                viewPassword_icon: this.state.isPasswordVisible ? 'eyeoff' : 'eye',
                                                showTooltip: true,
                                                id: 'password'
                                            }}
                                            component={Textfield}
                                            validate={[Validate.required, Validate.minLength8, Validate.maxLength16, Validate.password]}
                                            />
                                            <Field
                                            name="confirmPassword"
                                            props={{
                                                viewPassword: true,
                                                input_type: confirmPasswordType,
                                                label: 'Confirm New Password',
                                                viewPassword_press: this.viewConfirmPassword,
                                                viewPassword_icon: this.state.isPasswordConfirmationVisible ? 'eyeoff' : 'eye'
                                            }}
                                            component={Textfield}
                                            validate={[Validate.passwordMatch, Validate.required]}
                                            />
                                            <Button type='submit' disabled={invalid|| submitting || pristine} login label="Reset Password" />                                      
                                        </form>                                       
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </BackgroundImage>
        )
    }
}

const form = reduxForm({
    form: 'changePassword'
})

ChangePassword.propTypes = {
    forgotPassword: PropTypes.func,
    email: PropTypes.string,
}

const mapStateToProps = (state) => {
    const selector = formValueSelector('changePassword');
        return {
            password: selector(state, 'password'),
            verifyError: state.userReducer.verifyError,
            verifySuccess: state.userReducer.verifySuccess,
            verifyData: state.userReducer.verifyData,
            loading: state.userReducer.loading,
            passwordSuccess: state.userReducer.passwordSuccess,
            passwordError: state.userReducer.passwordError,
            changePassData: state.userReducer.changePassData,
            showLoading: state.loadingReducer.showLoading
        } 
    }
    
const mapDispatchToProps = (dispatch) => {
    return {
        forgotPasswordVerifyLink: (userData) => dispatch(forgotPasswordVerifyLink(userData)),
        forgotPasswordChangePassword: (userData) => dispatch(forgotPasswordChangePassword(userData)),
        clearState: () => dispatch(clearUserState())
    }
}
    
export default compose(
    form,
    connect(
        mapStateToProps,
        mapDispatchToProps)
)(ChangePassword)